import styled, { css } from 'styled-components'
import Scrollspy from 'react-scrollspy'
import { themeContract } from './StickyNav.theme.contract'

const Container = styled(Scrollspy)`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  min-width: 320px;
  margin: 0 auto;
  border-top: 1px solid ${props => props.theme.color.monochrome.light};
  padding: 5px;
  height: 55px;

  ${props =>
    css`
      @media only screen and (max-width: ${props.theme.size.breakpoint['max-width'].sm}) {
        display: none;
      }
    `}
`

const ListItem = styled.li`
  text-align: center;
  position: relative;
  width: 200px;

  /* Have to use this class because its used by Scrollspy to set the item as active */
  &.active {
    ${props =>
      css`
        button {
          border-color: ${props.theme.color.palette[themeContract[props.theme.channel].button.borderColor]};
          color: ${props.theme.color.palette[themeContract[props.theme.channel].button.colorActive]};
        }
      `}

    ${props =>
      props.isOpen &&
      css`
        button {
          background-color: ${props.theme.color.palette[themeContract[props.theme.channel].button.background]};
          border-color: ${props.theme.color.palette[themeContract[props.theme.channel].button.borderColor]};
          width: 100%;
          height: 100%;
          color: ${props.theme.color.palette[themeContract[props.theme.channel].button.color]};
        }
      `}
  }

  &.active {
    ::before {
      color: transparent;
    }
  }

  &:first-child {
    ::before {
      color: transparent;
    }
  }

  ::before {
    position: absolute;
    content: '|';
    top: 25%;
    left: 0;
    color: ${props => props.theme.color.monochrome.light};
  }
`

const Button = styled.button`
  font-size: 100%;
  font: inherit;
  cursor: pointer;
  letter-spacing: 1px;
  width: 100%;
  height: 100%;
  padding: 10px 0;
  background: transparent;
  border-radius: 3px;
  border: 2px solid ${props => props.theme.color.monochrome.lighter};
  color: ${props => props.theme.color.monochrome.dark};
`

export { Container, ListItem, Button }
